/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:39:08 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-11-24 14:53:59
 */
import { parsePx } from '@/core/element';

const deepClone = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};
// #! 编辑状态，不可以点击的元素，因为点击按钮会触发一些默认行为，比如表单提交等
const disabledPluginsForEditMode = ['t-video'];
const DEFAULT_STYLE = {
  top: 100,
  left: 100,
  width: 100,
  height: 40,
  zindex: 1,
  textAlign: 'center',
  color: '#000000',
  backgroundColor: '#ffffff',
  fontSize: 14
};

class Element {
  constructor(ele) {
    this.name = ele.name;
    this.canEdit = ele.canEdit;
    this.isContainer = ele.isContainer || false;
    this.uuid = ele.uuid || +new Date();
    this.pluginProps = (typeof ele.pluginProps === 'object' && deepClone(ele.pluginProps)) || this.getDefaultPluginProps(ele.editorConfig || {});
    this.commonStyle = (typeof ele.commonStyle === 'object' && deepClone(ele.commonStyle)) || { ...DEFAULT_STYLE, zindex: ele.zindex };
    this.events = [];
    this.animations = ele.animations || [];
  }

  getDefaultPluginProps (editorConfig) {
    // init prop of plugin
    const propConf = editorConfig.propsConfig;
    const pluginProps = {};
    Object.keys(propConf).forEach(key => {
      if (key === 'name') {
        console.warn('Please do not use {name} as plugin prop')
        return false;
      }
      pluginProps[key] = propConf[key].defaultPropValue;
    })
    return pluginProps;
  }

  getStyle ({ position = 'static', isRem = false } = {}) {
    if (this.name === 't-background') {
      return {
        width: '100%',
        height: '100%'
      }
    }
    const pluginProps = this.pluginProps;
    const commonStyle = this.commonStyle;
    const style = {
      top: parsePx(pluginProps.top || commonStyle.top, isRem),
      left: parsePx(pluginProps.left || commonStyle.left, isRem),
      bottom: parsePx(pluginProps.bottom || commonStyle.bottom, isRem),
      right: parsePx(pluginProps.right || commonStyle.right, isRem),
      width: parsePx(pluginProps.width || commonStyle.width, isRem),
      height: parsePx(pluginProps.height || commonStyle.height, isRem),
      fontSize: parsePx(pluginProps.fontSize || commonStyle.fontSize, isRem),
      color: pluginProps.color || commonStyle.color,
      textAlign: pluginProps.textAlign || commonStyle.textAlign,
      'z-index': commonStyle.zindex,
      position
    };

    return style;
  }

  getProps ({ mode = 'edit' } = {}) {
    return {
      ...this.pluginProps,
      disabled: disabledPluginsForEditMode.includes(this.name) && mode === 'edit'
    }
  }

  getAttrs () {
    return {
      'data-uuid': this.uuid
    }
  }

  /**
   * 
   * @param {object} config { position = 'static' } = {}
   */
  getPreviewData (config) {
    const style = this.getStyle(config);
    const data = {
      style,
      props: this.getProps({ mode: 'preview' }),
      attrs: this.getAttrs()
    };

    return data;
  }

  clone ({ zindex = this.commonStyle.zindex + 1 } = {}) {
    return new Element({
      zindex,
      name: this.name,
      pluginProps: this.pluginProps,
      commonStyle: {
        ...this.commonStyle,
        top: this.commonStyle.top + 20,
        left: this.commonStyle.left + 20
      }
    });
  }
}

export default Element;



// WEBPACK FOOTER //
// ./src/module/album/engine/element.js